import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result || '');
    reader.onerror = () => reject(new Error('Neuspesno citanje fajla.'));
    reader.readAsDataURL(file);
  });

export const fetchMedications = async ({
  page = 1,
  limit = 10,
  search = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;
    if (search) {
      query += `&search=${encodeURIComponent(search)}`;
    }

    const response = await authClient.get(`/medications${query}`);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju lekova.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const createMedication = async (payload) => {
  try {
    const response = await authClient.post('/medications', payload);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Lek kreiran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri kreiranju leka.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateMedication = async (id, payload) => {
  try {
    const response = await authClient.put(`/medications/${id}`, payload);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Lek azuriran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju leka.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const deleteMedication = async (id) => {
  try {
    const response = await authClient.delete(`/medications/${id}`);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Lek obrisan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri brisanju leka.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const importMedicationsFromExcel = async (file) => {
  try {
    const fileBase64 = await toBase64(file);
    const response = await authClient.post('/medications/import', {
      fileBase64,
    });

    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Lekovi importovani.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri importu lekova.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};
